export const general = {
  fr: {
    wait: "Veuillez attendre",
    noData: "Il n'y a aucune donnée à afficher",
    message: {
      operationFailed: "L'opération a échoué",
      bookingDeleted: "Réservation effacée avec succès",
      placeDeleted: "Établissement effacé avec succès",
      placeUpdated: "Établissement mise à jour avec succès",
      placeCreated: "Nouvel établissement créé",
      MenuAdded: "Menu ajouté avec succès",
      userCreated: "Nouvel utilisateur créé",
      placeAdminPartnerCreated: "Nouveau partenaire d'établissement créé",
      placeAdminPartnerUpdated:
        "Partenaire d'établissement mis à jour avec succès",
      userDeleted: "Utilisateur effacé avec succès",
      categoryCreated: "Nouvelle catégorie créée",
      categoryUpdated: "Catégorie mise à jour avec succès",
      categoryDeleted: "Catégorie effacée avec succès",
      partnerCreated: "Nouveau partenaire créé",
      partnerDeleted: "Partenaire effacé avec succès",
      partnerUpdated: "Partenaire mis à jour avec succès",
      chatSuggestionDeleted: "Message suggéré effacé avec succès",
      chatSuggestionUpdateded: "Message suggéré mis à jour avec succès",
      cityCreated: "Nouvelle ville créée",
      cityUpdated: "Ville mise à jour avec succès",
      cityDeleted: "Ville effacée avec succès",
      offerCreated: "Nouvelle offre créée",
      offerUpdated: "Offre mise à jour avec succès",
      offerDeleted: "Offre effacée avec succès",
      eventCreated: "Nouvel évènement créé",
      eventUpdated: "Évènement mis à jour avec succès",
      eventDeleted: "Évènement effacé avec succès",
      eventTypeDeleted: "Évènement effacé avec succès",
      eventTypeCreated: "Nouvel Évènement créé",
      eventTypeUpdated: "Évènement mis à jour avec succès",
      packCreated: "Nouveau pack créé",
      packUpdated: "Pack mis à jour avec succès",
      packDeleted: "Pack effacé avec succès",
      packItemDeleted: "L'élément du pack effacé avec succès",
      UserAvatarUpdated: "Photo d'utilisateur mise à jour avec succès",
      logout: "Voulez-vous vraiment vous déconnecter ?",
      reviewDeleted: "Avis effacé avec succès",
      noDataToShow: "Pas de données à afficher",
      openingHrAdded: "Horaires d'ouverture ajoutés avec succès",
      serviceAdded: "Service ajouté avec succès",
      serviceDeleted: "Service effacé avec succès",
      serviceUpdated: "Service mis à jour avec succès",
      passwordFailed:
        "Le nouveau mot de passe ne correspond pas au mot de passe de confirmation",
      passwordSucces: "Fermeture de session réussie",
      emailDeleted: "Email effacé avec succès",
      inspectorDeleted: "Inspecteur effacé avec succès",
      inspectorCreated: "Nouvel inspecteur créé",
      pictureDeleted: "Photo effacée avec succès",
      pictureUploaded: "Photos téléchargées avec succès",
      profileUpdated: "Profil mis à jour avec succès",
      failedToCreateZone: "Échec de la création de la zone",
      failedToUpdateZone: "Échec de la mise à jour de la zone",
      zoneUpdate: "Zone actualisée avec succès",
      zoneDeleted: "Zone supprimée avec succès",
      FailedToUpdateAdmin:
        "Échec de la mise à jour de l'administrateur de l'établissement",
      companyInfoUpdated:
        "Les informations de la société ont été mises à jour avec succès",
      notificationCreated: "Notification créée avec succès",
      password: {
        success: "Mot de passe mis à jour avec succès",
        failed: "Échec de la mise à jour du mot de passe",
      },
      payoutRequestCreated: "Votre demande de retrait est prise en charge",
      withdrawalProcessed: "La demande est marquée comme traitée avec succès",
      specialEventCreated: "Nouvel évènement spécial créé",
      tourOfferCreated: "Nouvelle offre de tourisme créée",
      menuAdded: "Menu ajouté avec succès",
      variableDeleted: "Variable effacée avec succès",
      translationCreated: "La traduction a été créée avec succès",
      translationUpdated: "La traduction a été mise à jour avec succès",
      rideBonusCreated: "Bonus de trajet ajouté avec succès",
      rideStatusChanged: "Statut du trajet mise à jour avec succès",
      invoiceCreated: "Facture créée avec succès",
      invoiceStatusUpdated: "Statut de la facture mise à jour avec succès",
      rewardTranslationDeleted: "Traduction de bonus effacée avec succès",
      specialTranslationDeleted: "Traduction de spécial effacée avec succès",
      deleteRewardTranslationConfirm:
        "Voulez-vous vraiment supprimer cette traduction de bonus ?",
      noRewardTranslations: "Aucune traduction de Bonus trouvée",
      specialDeleted: "Spécial effacé avec succès",
      serviceCategoryDeleted: "Catégorie de service effacée avec succès",
      serviceSubCategoryDeleted:
        "Sous-catégorie de service effacée avec succès",
      operationSuccess: "Opération réussie",
      rewardDeleted: "Bonus effacée avec succès",
      rewardTranslationCreated: "Nouvelle traduction de bonus créée",
      rewardTranslationUpdated: "Traduction de bonus mise à jour avec succès",
    },
    validation: {
      required: "Ce champ est obligatoire",
    },
    delete: "Voulez-vous vraiment supprimer cet élément ?",
    noResultsFound: "Aucun résultat trouvé",
    searchPlaceholder: "Rechercher...",
    actions: "Actions",
    confirmation: "Confirmation",
    noRewardTranslations: "Aucune traduction de Bonus trouvée",
    noSpecialTranslations: "Aucune traduction de spécial trouvée",
  },
};
